// src/pages/ForgotPasswordPage.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ForgotPassword from '@components/auth/ForgotPassword';
import { useAuth } from '@context/AuthContext';

const ForgotPasswordPage = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !isLoading) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) return null;

  return <ForgotPassword />;
};

export default ForgotPasswordPage;
